import { render, staticRenderFns } from "./QueueSummary.vue?vue&type=template&id=37fdb403&"
import script from "./QueueSummary.vue?vue&type=script&lang=js&"
export * from "./QueueSummary.vue?vue&type=script&lang=js&"
import style0 from "./QueueSummary.vue?vue&type=style&index=0&id=37fdb403&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports